/* Copyright (c) 2020-present CloudIO Inc */

import { Platform } from '../../platform/Platform';
import { ComponentManagerFn } from '../../registry/Component.type';
import { ItemType } from '../../registry/ComponentRegistry';
import { baseComponentManager } from '../../registry/Components';
import { sortItem } from '../Page/PageManager';
import { defaultValue } from './Folder';
import { analyzeFolder } from './FolderAnalyze';

const FolderManager: ComponentManagerFn<'Folder'> = (platform: Platform) => {
  return {
    ...baseComponentManager<'Folder'>(platform, 'Folder'),
    type: 'Folder',
    name: 'Folder',
    isChildAllowed: (page, item, childType) =>
      (
        [
          'Comments',
          'DataStore',
          'Drawer',
          'Folder',
          'CloudDataStore',
          'LocalDataStore',
          'Popup',
          'ReadOnlyDataStore',
          'Transaction',
          'TransientDataStore',
        ] as ItemType[]
      ).includes(childType),
    canHaveChildren: () => true,
    category: 'Containers',
    layout: 'sizeAware',
    onChildMoveIn: ({ page, value }) => {
      // DataStore must be on top before any other item type
      value.children = value.children.sort((a, b) => {
        const aItem = page[a];
        const bItem = page[b];
        if (aItem && bItem) {
          return sortItem(aItem, bItem, [
            'Folder',
            'CloudDataStore',
            'DataStore',
            'LocalDataStore',
            'ReadOnlyDataStore',
            'TransientDataStore',
            'Transaction',
            'Comments',
            'DataStore',
            'Popup',
          ]);
        }
        return 0;
      });
    },
    defaultValue,
    props: {
      name: {
        label: 'Name',
        type: 'string',
      },
      icon: {
        label: 'Icon',
        type: 'iconselect',
      },
    },
    getDisplayText: (item) => item.props.name,
    icon: (item) => item.props.icon ?? { iconName: 'folder' },
    analyze: analyzeFolder,
    description:
      "Folders are used to organize page level components like Stores & Popups in logical groups. This component is logical and won't render anything visible.",
  };
};

export default FolderManager;
